import { useState, useContext } from "react";
import { useFirestoreOrderBy } from "../../firebase/useFirestore";
import { db, timestamp } from "../../firebase/config";
import { Auth } from "../../StateManagment/Auth";
import { client } from "../../hooks/Client";
import uuid from "react-uuid";
import DeleteModal from "../common/DeleteModal";
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { useHistory } from "react-router-dom";
import Table from "../common/table/Table.jsx";
import TableCell from "../common/table/TableCell.jsx";
import TableTitleCell from "../common/table/TableTitleCell.jsx";

const StorytellingInterviewsTab = () => {
  const history = useHistory();
  const [auth] = useContext(Auth);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteDocid, setDeleteDocid] = useState("");
  const [deleteName, setDeleteName] = useState("dit interview");

  const interviews = useFirestoreOrderBy("StorytellingInterviews", "Position", "desc");

  const formatDate = (firebaseTimestamp) => {
    if (!firebaseTimestamp || typeof firebaseTimestamp.toDate !== "function") {
      return "-";
    }

    const date = firebaseTimestamp.toDate();
    return new Intl.DateTimeFormat("nl-NL", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }).format(date);
  };

  const addInterview = async () => {
    const id = uuid();

    await db.collection("StorytellingInterviews").doc().set({
      ID: id,
      Compagny: client,
      CompagnyID: client,
      Timestamp: timestamp,
      Type: "deelnemer",
      LanguageCode: "nl",
      Deleted: false,
      Position: interviews ? interviews.length : 0,
    });

    history.push(`/${client}/storytellinginterviewdetail/${id}`);
  };

  const titleHandler = async (e) => {
    const docid = e.target.dataset.docid;
    const title = e.target.value;

    await db.collection("StorytellingInterviews").doc(docid).update({
      Title: title,
    });
  };

  const openDeleteModal = (item) => {
    setDeleteDocid(item.docid);
    setDeleteName(`interview (${item.Type || "onbekend"})`);
    setDeleteModal(true);
  };

  // Soft delete (ADR-008): never hard-delete. Readers hide it via the central
  // useFirestore soft-delete filter and this tab's own `!item.Deleted` filter.
  const deleteInterview = async () => {
    if (!deleteDocid) {
      return;
    }

    await db.collection("StorytellingInterviews").doc(deleteDocid).update({
      Deleted: true,
      DeletedAt: timestamp,
      DeletedBy: auth?.ID || "",
    });
    setDeleteDocid("");
  };

  return (
    <>
      <Table
        columns={[
          { key: "title", label: "TITEL" },
          { key: "date", label: "DATUM", searchable: false },
          { key: "delete", label: "VERWIJDEREN", searchable: false },
        ]}
        items={(interviews || []).filter((item) => !item.Deleted)}
        getItemKey={(item) => item.ID}
        renderRow={(item) => (
          <>
            <TableTitleCell
              value={item.Title}
              to={`/${client}/storytellinginterviewdetail/${item.ID}`}
              onBlur={titleHandler}
              docid={item.docid}
              placeholder="Noteer hier de titel van het interview"
            />
            <TableCell>{formatDate(item.Timestamp)}</TableCell>
            <TableCell>
              <DeleteOutlinedIcon className="table-delete-icon" onClick={() => openDeleteModal(item)} />
            </TableCell>
          </>
        )}
        searchAccessor={(item) => `${item?.Title || ""} ${formatDate(item?.Timestamp)}`}
        searchPlaceholder="Zoeken op titel of datum"
        emptyMessage="Geen interviews gevonden."
        addRow={{
          toolTipContent: "Interview toevoegen",
          onClick: addInterview,
        }}
      />

      <DeleteModal
        deleteModal={deleteModal}
        setDeleteModal={setDeleteModal}
        deleteItem={deleteInterview}
        deleteName={deleteName}
      />
    </>
  );
};

export default StorytellingInterviewsTab;
